import { render, staticRenderFns } from "./StudioFooter.vue?vue&type=template&id=21c1a68c&scoped=true&"
import script from "./StudioFooter.vue?vue&type=script&lang=ts&"
export * from "./StudioFooter.vue?vue&type=script&lang=ts&"
import style0 from "./StudioFooter.vue?vue&type=style&index=0&id=21c1a68c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c1a68c",
  null
  
)

export default component.exports